"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var titles = __importStar(require("./modules/titles/actions"));
var home = __importStar(require("./modules/home/actions"));
var auth = __importStar(require("./modules/auth/actions"));
var spotify = __importStar(require("./modules/spotify/actions"));
var playback = __importStar(require("./modules/playback/actions"));
var search = __importStar(require("./modules/search/actions"));
var chromecast = __importStar(require("./modules/chromecast/actions"));
var channels = __importStar(require("./modules/channels/actions"));
var epg = __importStar(require("./modules/epg/actions"));
var playerNative = __importStar(require("./modules/playerNative/actions"));
var collections = __importStar(require("./modules/collections/actions"));
var devices = __importStar(require("./modules/devices/actions"));
var myStuff = __importStar(require("./modules/myStuff/actions"));
var remoteRecord = __importStar(require("./modules/remoteRecord/actions"));
var subscription = __importStar(require("./modules/subscription/actions"));
var parentalPin = __importStar(require("./modules/parentalPin/actions"));
var download2Go = __importStar(require("./modules/download2Go/actions"));
var userAttributes = __importStar(require("./modules/userAttributes/actions"));
var network = __importStar(require("./modules/network/actions"));
var messaging = __importStar(require("./modules/messaging/actions"));
var featureFlags = __importStar(require("./modules/featureFlags/actions"));
var app = __importStar(require("./modules/app/actions"));
var airplay = __importStar(require("./modules/airplay/actions"));
var myHub = __importStar(require("./modules/myHub/actions"));
var myApps = __importStar(require("./modules/myApps/actions"));
var recordings = __importStar(require("./modules/recordings/actions"));
var decoder = __importStar(require("./modules/decoder/actions"));
var customer = __importStar(require("./modules/customer/actions"));
var notificationsTV = __importStar(require("./modules/notificationsTV/actions"));
var dvb = __importStar(require("./modules/dvb/actions"));
var contextTV = __importStar(require("./modules/contextTV/actions"));
var tilesFocusTV = __importStar(require("./modules/tilesFocusTV/actions"));
var backgroundImage = __importStar(require("./modules/backgroundImage/actions"));
var accountPin = __importStar(require("./modules/accountPin/actions"));
var profilePreferences = __importStar(require("./modules/profilePreferences/actions"));
exports.default = {
    app: app,
    auth: auth,
    channels: channels,
    titles: titles,
    home: home,
    spotify: spotify,
    playback: playback,
    search: search,
    chromecast: chromecast,
    epg: epg,
    playerNative: playerNative,
    collections: collections,
    devices: devices,
    myStuff: myStuff,
    remoteRecord: remoteRecord,
    subscription: subscription,
    parentalPin: parentalPin,
    download2Go: download2Go,
    userAttributes: userAttributes,
    network: network,
    messaging: messaging,
    featureFlags: featureFlags,
    airplay: airplay,
    myHub: myHub,
    myApps: myApps,
    recordings: recordings,
    decoder: decoder,
    customer: customer,
    notificationsTV: notificationsTV,
    dvb: dvb,
    contextTV: contextTV,
    tilesFocusTV: tilesFocusTV,
    backgroundImage: backgroundImage,
    accountPin: accountPin,
    profilePreferences: profilePreferences,
};
//# sourceMappingURL=actions.js.map